import { defineMessages } from 'react-intl'

export default defineMessages({
  skip: {
    id: 'eligibilitypage.skip',
    defaultMessage: `{person, select,
      first {Check for my child or dependent}
      other {Skip}
    }`,
  },
  pageTitle: {
    id: 'eligibilitypage.pagetitle',
    defaultMessage: `{person, select,
      first {Check your eligibility}
      other {Check {name}’s eligibility}
    }`,
  },
  infoText: {
    id: 'eligibilitypage.infotext',
    defaultMessage: `{person, select,
      first {Enter your insurance plan details to get full access to Babylon services.}
      other {Enter their insurance plan details so that they get full access to Babylon services.}
    }`,
  },
})
